const store = new Map();
function deactivate(v) {
    if (typeof v.deactivate === "function") {
        v.deactivate().catch(undefined);
    }
}
export const connectionStore = {
    set: (k, v) => {
        store.set(k, v);
        return v;
    },
    get: (k) => store.get(k),
    getAll: () => [...store.values()],
    has: (k) => store.has(k),
    delete: (k) => {
        const v = store.get(k);
        if (typeof v !== "undefined") {
            deactivate(v);
        }
        return store.delete(k);
    },
    clear: () => {
        store.forEach(deactivate);
        store.clear();
    }
};
window.addEventListener("beforeunload", () => {
    connectionStore.clear();
});
//# sourceMappingURL=ConnectionStore.js.map